module.exports = __webpack_public_path__ + "img/02_1.46f3b7b.png";